import { enums } from '@adc/sdk'
import * as graph from '@adc/sdk'
import { ListingParty, CurrentTargetAudience, Maybe } from '@adc/sdk/types'

export const findSellerRepresentative = (
  listingParties: Maybe<ListingParty>[],
  viewingFrom: CurrentTargetAudience
): Maybe<ListingParty> | undefined => {
  const listingAgent = listingParties?.find(
    party => party?.party_role === enums.ListingPartyRole.ListingAgent
  )

  if (
    viewingFrom === graph.enums.CurrentTargetAudience.Staff &&
    !listingAgent
  ) {
    return listingParties?.find(
      party => party?.party_role === enums.ListingPartyRole.PrivateSeller
    )
  } else {
    return listingAgent
  }
}
